import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryServicePage,
  buildIndustryServiceHead,
} from "@/components/IndustryServicePage";
import { getIndustryServiceCombo } from "@/lib/industryServiceData";

const combo = getIndustryServiceCombo("web-design", "electrical")!;

export const Route = createFileRoute("/web-design-for-electrical")({
  head: () => buildIndustryServiceHead(combo),
  component: () => <IndustryServicePage combo={combo} />,
});
